export enum EventType {
	AUTHENTICATION_SERVICE_READY_EVENT = 'AuthenticationServiceReadyEvent',
	YOLO_NOT_DISPLAYED_EVENT = 'YoloNotDisplayedEvent',
	AUTHENTICATION_COMPLETED = 'AuthenticationCompleted',
}
